import React from "react";

import Settings from "../features/settings/settings";


const DashboaedSettings =()=>{

    return(
        <Settings/>
    );
}
export default DashboaedSettings;